import { AnimeAnimParams, AnimeParams } from "animejs";
import { Keyframe } from "../handlers/animation/AnimationKeyframeHandler";
import { ObjectMeasures } from "./canvas.model";

export type AnimationConfig = {
  option: AnimeParams;
  offset: number;
};

export type AnimationConfigParams = {
  fabricObject: any;
  fabricObjectClone: any;
  effect: any;
  animatedObjects: any[];
  loopEnabled: boolean;
  loopOption: any;
  workarea: ObjectMeasures;
  isSinglePreview: boolean;
  extras: AnimationConfigExtraParams;
  storeOriginalProperties: boolean;
};

export type AnimationConfigExtraParams = {
  objects?: any[];
  canvas?: fabric.Canvas;
  delay?: number;
};

export interface KeyframeOptions extends AnimeAnimParams {
  keyframes: Keyframe[];
}

export interface KeyframeConfig {
  option: KeyframeOptions;
  offset?: number;
}

export enum FLY_ANIMATIONS {
  FLY_IN_TOP = `fly_in_top`,
  FLY_IN_BOTTOM = `fly_in_bottom`,
  FLY_IN_LEFT = `fly_in_left`,
  FLY_IN_RIGHT = `fly_in_right`,
  FLY_OUT_TOP = `fly_out_top`,
  FLY_OUT_BOTTOM = `fly_out_bottom`,
  FLY_OUT_LEFT = `fly_out_left`,
  FLY_OUT_RIGHT = `fly_out_right`,
}

export enum FADE_ANIMATIONS {
  FADE_IN = "fade_in",
  FADE_OUT = "fade_out",
}

export enum ZOOM_ANIMATIONS {
  ZOOM_IN = "zoom_in",
  ZOOM_OUT = "zoom_out",
  STOMP = `stomp`,
  BREATHE = `breathe`,
}

export enum SHIFT_ANIMATIONS {
  SHIFT_TOP = `shift_top`,
  SHIFT_BOTTOM = `shift_bottom`,
  SHIFT_LEFT = `shift_left`,
  SHIFT_RIGHT = `shift_right`,
}

export enum TUMBLE_ANIMATIONS {
  TUMBLE_IN = `tumble_in`,
  TUMBLE_OUT = `tumble_out`,
}

export enum FLICKER_ANIMATIONS {
  FLICKER = `flicker`,
}

export enum PULSE_ANIMATIONS {
  PULSE = `pulse`,
}

export enum WIPE_ANIMATIONS {
  WIPE_IN_TOP = "wipe_in_top",
  WIPE_IN_BOTTOM = "wipe_in_bottom",
  WIPE_IN_LEFT = "wipe_in_left",
  WIPE_IN_RIGHT = "wipe_in_right",
  WIPE_OUT_TOP = "wipe_out_top",
  WIPE_OUT_BOTTOM = "wipe_out_bottom",
  WIPE_OUT_LEFT = "wipe_out_left",
  WIPE_OUT_RIGHT = "wipe_out_right",
}

export enum REVEAL_ANIMATIONS {
  REVEAL_IN_TOP = "reveal_in_top",
  REVEAL_IN_BOTTOM = "reveal_in_bottom",
  REVEAL_IN_LEFT = "reveal_in_left",
  REVEAL_IN_RIGHT = "reveal_in_right",
  REVEAL_OUT_TOP = "reveal_out_top",
  REVEAL_OUT_BOTTOM = "reveal_out_bottom",
  REVEAL_OUT_LEFT = "reveal_out_left",
  REVEAL_OUT_RIGHT = "reveal_out_right",
}

export enum BLOCK_REVEAL_ANIMATIONS {
  BLOCK_REVEAL_IN_TOP = "block_in_top",
  BLOCK_REVEAL_IN_BOTTOM = "block_in_bottom",
  BLOCK_REVEAL_IN_LEFT = "block_in_left",
  BLOCK_REVEAL_IN_RIGHT = "block_in_right",
  BLOCK_REVEAL_OUT_TOP = "block_out_top",
  BLOCK_REVEAL_OUT_BOTTOM = "block_out_bottom",
  BLOCK_REVEAL_OUT_LEFT = "block_out_left",
  BLOCK_REVEAL_OUT_RIGHT = "block_out_right",
}

export enum CUSTOM_ANIMATIONS {
  GREAT_THINKER = "great_thinker",
  SUNNY_MORNINGS = "sunny_mornings",
  RISING_STRONG_IN = "rising_strong_in",
  RISING_STRONG_OUT = "rising_strong_out",
  MADE_WITH_LOVE = "made_with_love",
  BEAUTIFUL_QUESTIONS = "beautiful_questions",
  DOMINO_DREAMS = "domino_dreams",
  COFFEE_MORNINGS = "coffee_mornings",
  A_NEW_PRODUCTION_IN = "a_new_production_in",
  A_NEW_PRODUCTION_OUT = "a_new_production_out",
  FIND_YOUR_ELEMENT = "find_your_element",
  THURSDAY = "thursday",
  HELLO_GOODBYE = "hello_goodbye",
}

export type ANIMATIONS =
  | ZOOM_ANIMATIONS
  | TUMBLE_ANIMATIONS
  | FADE_ANIMATIONS
  | SHIFT_ANIMATIONS
  | FLY_ANIMATIONS
  | FLICKER_ANIMATIONS
  | PULSE_ANIMATIONS
  | WIPE_ANIMATIONS
  | REVEAL_ANIMATIONS
  | BLOCK_REVEAL_ANIMATIONS
  | CUSTOM_ANIMATIONS;
